import type { ThemeName } from '@lunary/ui-tokens'
import { Icon } from './icons'
import type { IconName } from './icons'
import { useLiquidPill } from './use-liquid-pill'
import type { PillGeometry } from './use-liquid-pill'
import styles from './theme-switch.module.css'

const OPTIONS: ReadonlyArray<{ value: ThemeName; label: string; icon: IconName }> = [
  { value: 'light', label: 'Светлая тема', icon: 'sun' },
  { value: 'dark', label: 'Тёмная тема', icon: 'moon' },
]

const measure = (group: HTMLElement, item: HTMLElement): PillGeometry => ({
  left: item.offsetLeft,
  right: group.clientWidth - item.offsetLeft - item.offsetWidth,
})

const PILL = { base: 'top .2s ease, bottom .2s ease', squash: 4, measure }

type Props = {
  theme: ThemeName
  onChange: (theme: ThemeName) => void
  labelledBy?: string
}

export function ThemeSwitch({ theme, onChange, labelledBy }: Props) {
  const { pillRef, register } = useLiquidPill<HTMLSpanElement>(theme, PILL)

  return (
    <div
      className={styles.group}
      role="radiogroup"
      aria-label={labelledBy ? undefined : 'Тема'}
      aria-labelledby={labelledBy}
    >
      <span ref={pillRef} className={styles.pill} aria-hidden="true" />
      {OPTIONS.map(({ value, label, icon }) => (
        <button
          key={value}
          ref={register(value)}
          type="button"
          role="radio"
          aria-checked={value === theme}
          aria-label={label}
          className={styles.option}
          onClick={() => {
            if (value !== theme) onChange(value)
          }}
        >
          <Icon name={icon} size={18} stroke={1.7} />
        </button>
      ))}
    </div>
  )
}
